import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServiceCard from "../components/ServiceCard";
import SEO from "../components/SEO";

const services = [
  {
    title: "Post Construction Cleaning",
    description:
      "Comprehensive post-renovation and construction cleaning. We remove all dust, debris, and building materials, leaving your space spotless and move-in ready.",
    image:
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80",
    link: "/services/post-construction",
  },
  {
    title: "Training & Certifying Cleaners",
    description:
      "Professional training programmes for aspiring cleaners. We provide comprehensive certification courses covering all aspects of professional cleaning.",
    image: "/images/clean5.JPG",
    link: "/services/training-certifying",
  },
  {
    title: "Hiring Maids",
    description:
      "Thoroughly vetted, trained, and trustworthy domestic staff. All our maids undergo background checks, training, and continuous supervision.",
    image:
      "https://images.unsplash.com/photo-1581578731350-86e0c7562913?w=800&q=80",
    link: "/services/hiring-maids",
  },
  {
    title: "Fumigation Services",
    description:
      "Professional pest control and fumigation for homes and businesses. Safe, effective treatments for all types of pests.",
    image:
      "https://images.unsplash.com/photo-1563453392212-326f5e854473?w=800&q=80",
    link: "/services/fumigation",
  },
  {
    title: "Roof Tile Cleaning",
    description:
      "Specialised roof and tile cleaning services. We remove moss, algae, and stains, extending the life of your roof and improving curb appeal.",
    image:
      "https://images.unsplash.com/photo-1632778297991-82ee0a353f03?w=800&q=80",
    link: "/services/roof-tile-cleaning",
  },
  {
    title: "Deep Cleaning",
    description:
      "Intensive deep cleaning that reaches every corner. Perfect for spring cleaning, move-in/move-out, or when your space needs a thorough refresh.",
    image:
      "https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=800&q=80",
    link: "/services/deep-cleaning",
  },
  {
    title: "Laundry Cleaning From Homes",
    description:
      "Convenient laundry collection and delivery service. Professional washing, drying, ironing, and folding — all from the comfort of your home.",
    image:
      "https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=800&q=80",
    link: "/services/laundry-from-homes",
  },
  {
    title: "Vacuum Cleaning",
    description:
      "Professional vacuum cleaning for sofas, chairs, and carpets. Deep extraction cleaning removes dirt, allergens, and odours.",
    image:
      "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80",
    link: "/services/vacuum-cleaning",
  },
];

const Services = () => {
  return (
    <>
      <SEO 
        title="Our Cleaning Services in Kampala | Post-Construction, Deep Cleaning, Fumigation & More"
        description="Comprehensive cleaning services in Kampala: Post-construction cleaning, deep cleaning, fumigation, maid services, vacuum cleaning, laundry services & cleaner training. Professional & affordable. Call 0752 058 190"
        keywords="cleaning services Kampala Uganda, post construction cleaning, deep cleaning services, fumigation Kampala, maid hiring Uganda, carpet cleaning, commercial cleaning, residential cleaning Kampala"
        url="https://blossomcleaningservices.com/services"
      />
      <Header />

      {/* Hero Section */}
      <Box
        sx={{
          py: 12,
          backgroundColor: "primary.main",
          color: "white",
          textAlign: "center",
        }}
      >
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              sx={{
                mb: 3,
                color: "white",
                fontSize: { xs: "2.5rem", md: "3.5rem" },
              }}
            >
              Our Services
            </Typography>
            <Typography
              variant="h5"
              sx={{
                maxWidth: 800,
                mx: "auto",
                color: "rgba(255,255,255,0.95)",
              }}
            >
              Comprehensive cleaning solutions for every need — from residential
              to commercial properties
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Services Grid */}
      <Box sx={{ py: 8, backgroundColor: "background.default" }}>
        <Container>
          <Grid container spacing={4}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <ServiceCard {...service} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default Services;
